import React from "react";
import Layout from "../../components/layout/Layout";
import OfficeCustomerSummaryView from "../../components/views/OfficeCustomerSummaryView";

export default function OfficeCustomerSummary() {
  return (
    <Layout>
      <OfficeCustomerSummaryView />
    </Layout>
  );
}
